module.exports = new __parcel__URL__("appache.05448315.svg").toString();